import {DocumentContext, DocumentEntityType} from '@sollapay/enums';
import {useMutation, useQueryClient} from '@tanstack/react-query';

import {documentKeys} from '@/features/documents';
import {trustAccountActivityKeys} from '@/features/trust-accounts/hooks/useTrustAccountActivity';
import {useApiClient} from '@/hooks';

import {payoutsApi} from '../api';
import {payoutInstructionKeys} from './usePayoutInstructionsQuery';

import type {CreatePayoutInstructionPayload} from '@sollapay/types';

export interface CreatePayoutMutationVariables {
  payload: CreatePayoutInstructionPayload;
  stepUpToken: string;
}

export function useCreatePayoutMutation(trustAccountId: string) {
  const client = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({payload, stepUpToken}: CreatePayoutMutationVariables) => {
      const response = await payoutsApi.createPayout(client, trustAccountId, payload, stepUpToken);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: payoutInstructionKeys.lists(trustAccountId)});
      queryClient.invalidateQueries({queryKey: trustAccountActivityKeys.all(trustAccountId)});
      // Creation links the creditor document server-side; a stale cached copy blocks its reuse.
      queryClient.invalidateQueries({
        queryKey: documentKeys.list(
          DocumentEntityType.TRUST_ACCOUNT,
          trustAccountId,
          DocumentContext.PAYOUTS
        )
      });
    }
  });
}
